
<div class="canvas row position-relative pt-4">
  <SchemaDesignerNode
    v-for="(property, key) in node.properties"
    :key="key"
    :node="property"
  />
  <slot name="node-actions" />
</div>
